import { createAction, props } from '@ngrx/store';

export enum SeSideKeyImagesComponentActions {
    SET_KEY_IMAGES_DATA = '[SeSideKeyImagesComponent] SetKeyImagesData',
    SET_KEY_IMAGES_FOR_ROW_IN_PLACEHOLDER = '[SeSideKeyImagesComponent] SetImagesPerRowInPlaceholder',
    NO_RESULT = '[SeSideKeyImagesComponent] NoResult',
    SET_SELECTED_ITEMS = '[SeSideKeyImagesComponent] SetSelectedItem',
    
}

export const seSideKeyImagesComponentSetKeyImagesData =
    createAction(SeSideKeyImagesComponentActions.SET_KEY_IMAGES_DATA, props<{ formType: any; keyImages: any[] }>());

export const seSideKeyImagesComponentSetImagesPerRowInPlaceholder =
    createAction(SeSideKeyImagesComponentActions.SET_KEY_IMAGES_FOR_ROW_IN_PLACEHOLDER, props<{ formType: any; imagesPerRowInPlaceholder: number }>());

export const seSideKeyImagesComponentNoResult =
    createAction(SeSideKeyImagesComponentActions.NO_RESULT, props < { formType: any; message: string }>());

export const seSideKeyImagesComponentSetSelectedItem =
    createAction(SeSideKeyImagesComponentActions.SET_SELECTED_ITEMS, props<{ formType: any; selectedItems:any[]}>());
